export const language: any = {
  selected_ingredients: "Ausgewählte Zutaten",
  recommend: "Empfohlene Gerichte",
  title_detail: "Empfohlene Rezepte",
  share: "Teilen",
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">Zutaten</span> <span class="tracking-tighter whitespace-nowrap">(1 Portion)</span>`,
    add_all: "Alle Zutaten hinzufügen",
    view_more: "{number} weitere Zutaten",
    view_less: "Einklappen",
    delete_all: "Alle Zutaten entfernen"
  },
  how_to_cook: "Zubereitungsmethode",
  video: {
    title: "Video-Rezept"
  },
  msg: {
    msg_1: "Möchten Sie diese Zutat wirklich löschen?",
    msg_2: "Möchten Sie wirklich alle Zutaten löschen?",
    msg_3: "Möchten Sie die Zutaten hinzufügen?",
    msg_4: "Möchten Sie alle fehlenden Zutaten hinzufügen?",
    msg_5: "Möchten Sie die ausgewählten Zutaten in Ihren Einkaufswagen legen?",
    msg_6: "Diese Zutat befindet sich bereits in Ihrem Einkaufswagen.",
    confirm: "Ja",
    cancel: "Nein"
  },
  recipe_exist_in_cart: "Diese Zutat befindet sich bereits in Ihrem Einkaufswagen.",
  recipe_want_add_to_cart: "Möchten Sie die ausgewählten Zutaten in Ihren Einkaufswagen legen?",
  recipe_exist_in_cart_should_exclued: "befindet sich bereits im aktuellen Warenkorb und wurde daher ausgeschlossen.",
  calories_description: "Dieses Gericht enthält schätzungsweise {calories} Kalorien basierend auf dem untenstehenden Rezept. Bitte treffen Sie eine bewusste Wahl für Ihre Gesundheit!",
  title_share_sns: "Teilen Sie dieses Rezept auf",
  copy: "Kopieren",
  recipe_add_cart_success: "Zum Warenkorb hinzugefügt. Möchten Sie zur Warenkorb-Seite wechseln?",
  recipe_close: "Schließen",
  recipe_move: "Wechseln",
  recipe_add_ingredient_success: "Die ausgewählte Zutat wurde hinzugefügt. Möchten Sie zum Zutaten-Bildschirm wechseln?",
  copied: "Kopiert",
  text_share_sns: `{recipe_name} – wie wäre es mit diesem Rezept?\nSchauen Sie es sich auf Hey! Cooker an!`,
  search: {
    title: "Rezepte suchen",
    searching: "Hey Cooker sucht nach Rezepten, die<br/> zu Ihren Stichwörtern passen. Bitte haben Sie einen Moment Geduld!",
    not_found: "Hmm, der KI-Koch konnte keine Gerichte finden,<br/> die zu Ihren Stichwörtern passen. Bitte versuchen Sie es mit einem anderen Rezeptnamen.",
    placeholder: "Geben Sie den Namen des Rezepts ein, nach dem Sie suchen möchten...",
    msg_default_recipe: "Sie haben noch keine Rezepte."
  },
  noData: "Keine Ergebnisse gefunden",
  searching: "Suche läuft..."
}
